<script setup lang="ts">
import { ref, onErrorCaptured } from 'vue';
import * as Sentry from '@sentry/vue';

const hasError = ref(false);

onErrorCaptured((error) => {
  Sentry.captureException(error);
  hasError.value = true;
  return false;
});

function retry() {
  hasError.value = false;
}
</script>

<template>
  <div
    v-if="hasError"
    class="min-h-screen flex items-center justify-center bg-fem-purple-darker px-4"
  >
    <div class="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 text-center space-y-4">
      <h2 class="text-xl font-bold text-fem-purple-dark">Wystąpił nieoczekiwany błąd</h2>
      <p class="text-sm text-gray-600">
        Przepraszamy, coś poszło nie tak. Spróbuj odświeżyć stronę lub kliknij poniżej.
      </p>
      <button
        class="px-6 py-2.5 rounded-lg text-white font-semibold text-sm bg-fem-purple hover:bg-fem-purple-dark transition-colors"
        @click="retry"
      >
        Spróbuj ponownie
      </button>
    </div>
  </div>
  <slot v-else />
</template>
